export const CODES_LIST = 'CODES_LIST'
export const CODES_ADD = 'CODES_ADD'
export const CODES_ENABLE = 'CODES_ENABLE'
export const CODES_UPDATE = 'CODES_UPDATE'



// WEBPACK FOOTER //
// ./src/store/actions/codes.js